#import "../../../../../core-entity/graphql/fragments/contact-for-core-entity-fragment.graphql"

mutation UpdateContactForLead($input: ContactUpdateInput!) {
    contactUpdate(input: $input) {
        contact {
            ...ContactForCoreEntityFragment
        }
    }
}
